module.exports = import("https://cdn.skypack.dev/canvas-confetti");;